import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../features';
import { ReportError } from '../../../models/report/ReportError';
import { ReportFailed } from '../../shared/report/ReportFailed';

export const DreamHistoryReportFailedDialog: React.FC = () => {
  const reportStatus = useSelector((state: RootState) => state.dream.historyDetail.reportStatus);
  let reportError: ReportError | undefined = undefined;
  let invalidChar: string[] | undefined = undefined;
  if (reportStatus?.state === 'error') {
    reportError = reportStatus.error;
  }

  if (reportError === undefined) {
    return <></>;
  } else {
    if (reportError.type === 'invalid-char') {
      invalidChar = reportError.char;
    }
  }

  return <ReportFailed errorType={reportError.type} invalidChar={invalidChar} />;
};
